<div
    [style.display]="selected ? '' : 'none'"
    role="tabpanel"
    [id]="id"
    class="agpr-sourceOutletsTab-outlets"
    [attr.aria-labelledby]="id"
>
    @if (hasTargetingPermission) {
        <div class="agpr-sourceOutletsTab-outlets-toolbar">
            <div class="agpr-sourceOutletsTab-outlets-filters">
                <div class="agpr-sourceOutletsTab-outlets-filters-dropdown">
                    <agpr-filter-dropdown
                        [id]="id + '_filterDropdown'"
                        [showQuickFilter]="true"
                        quickFilterPlaceholder="Discover.targeting.filter.quick.contactName.placeholder"
                        ariaLabel="Common.dialog.aeoScout.outlets.filterDropdown.ariaLabel"
                        [ariaDescribedBy]="id + '_filterDropdown'"
                    ></agpr-filter-dropdown>
                </div>
                <agpr-sort-order
                    [id]="id + '_sortOrder'"
                    [isDisabled]="!outletList?.length"
                    tooltip="Discover.targeting.tooltips.sort"
                    optionKey="enumValue"
                    optionLabel="displayString"
                ></agpr-sort-order>
            </div>
            @if (areChipsVisible) {
                <agpr-filter-chips
                    [id]="id + '_filterChips'"
                    class="agpr-sourceOutletsTab-filterChips"
                ></agpr-filter-chips>
            }

            <div class="agpr-sourceOutletsTab-listPicker">
                <agpr-dropdown
                    class="agpr-sourceOutletsTab-listPicker-dropdown"
                    [id]="id + '_addToOptions_dropdown'"
                    [options]="targetingAddToOptions"
                    [bindToValue]="true"
                    [(ngModel)]="addToType"
                    (ngModelChange)="selectTargetingType()"
                ></agpr-dropdown>
                @if (addToType === targetingAddToType.LIST) {
                    <agpr-autocomplete
                        [id]="id + '_listAutocomplete'"
                        class="agpr-sourceOutletsTab-listPicker-listAutocomplete"
                        labelField="name"
                        placeholder="Discover.listBuilder.widget.placeholder.dropdown"
                        [dropdown]="true"
                        dropdownMode="current"
                        [suggestions]="targetingLists$"
                        [multiSelection]="true"
                        [pTooltip]="'Discover.listBuilder.widget.tooltip.dropdown' | localize"
                        tooltipPosition="top"
                        ariaLabel="Discover.listBuilder.widget.placeholder.dropdown"
                        [ariaDescribedBy]="id + '_listPickerChips'"
                        [customOptions]="listBuilderOptions"
                        [(ngModel)]="selectedLists"
                        (itemSelected)="updateListBuilder()"
                    ></agpr-autocomplete>
                } @else {
                    <agpr-autocomplete
                        [id]="id + '_distributionAutocomplete'"
                        class="agpr-sourceOutletsTab-listPicker-distributionAutocomplete"
                        [(ngModel)]="selectedDistributions"
                        (itemSelected)="updateDistributionBuilder()"
                        labelField="name"
                        placeholder="Discover.distributionBuilder.widget.placeholder.dropdown"
                        [dropdown]="true"
                        dropdownMode="current"
                        [suggestions]="distributions$"
                        [multiSelection]="true"
                        [pTooltip]="'Discover.distributionBuilder.widget.tooltip.dropdown' | localize"
                        tooltipPosition="top"
                        [ariaLabel]="'Discover.distributionBuilder.widget.placeholder.dropdown'"
                        [showHiddenOption]="true"
                        [ariaDescribedBy]="id + '_distributionPickerChips'"
                    ></agpr-autocomplete>
                }
                <agpr-button
                    [id]="id + '_addTo_button'"
                    class="agpr-sourceOutletsTab-listPicker-addButton"
                    [ngClass]="{'agpr-sourceOutletsTab-listPicker-addButton--distribution' : addToType === targetingAddToType.DISTRIBUTION}"
                    [style]="buttonType.icon"
                    [icon]="addToType === targetingAddToType.LIST ? 'fa-regular fa-duotone fa-user-plus' : 'fa-kit-duotone fa-agpr-add-distribution'"
                    [disabled]="selectedOutlets.length === 0"
                    [tooltip]="addToType === targetingAddToType.LIST ? 'Common.dialog.aeoScout.outlets.addToList.tooltip' : 'Common.dialog.aeoScout.outlets.addToDistribution.tooltip'"
                    tooltipPosition="top"
                    (click)="addTo()"
                ></agpr-button>
            </div>

            @if (selectedListsChips?.length || selectedDistributionsChips?.length) {
                <div class="agpr-sourceOutletsTab-listPicker-chips">
                    @if (addToType === targetingAddToType.LIST) {
                        <agpr-chip-container
                            #listChipsComponent
                            [id]="id + '_listPickerChips'"
                            [chips]="selectedListsChips"
                            (removeChip)="listPickerService.removeWorkingListByIndex($event)"
                        ></agpr-chip-container>
                        @if (selectedLists.length > 1) {
                            <agpr-button
                                [id]="id + '_listBuilder_chips_clearButton'"
                                class="agpr-targetingResults-toolbarIcon-clear"
                                [style]="buttonType.link"
                                icon="agpr-i-clear"
                                tooltip="Discover.listBuilder.widget.tooltip.clearAll"
                                tooltipPosition="top"
                                (click)="clearListChips()"
                            ></agpr-button>
                        }
                    } @else {
                        <agpr-chip-container
                            #listChipsComponent
                            [id]="id + '_distributionPickerChips'"
                            [chips]="selectedDistributionsChips"
                            (removeChip)="distributionPickerService.removeWorkingDistributionByIndex($event)"
                        ></agpr-chip-container>
                        @if (selectedDistributions.length > 1) {
                            <agpr-button
                                [id]="id + '_distributionPicker_chips_clearButton'"
                                class="agpr-targetingResults-toolbarIcon-clear"
                                [style]="buttonType.link"
                                icon="fa-kit-duotone fa-agpr-remove-all"
                                tooltip="Discover.distributionBuilder.widget.tooltip.clearAll"
                                tooltipPosition="top"
                                (click)="clearDistributionChips()"
                            ></agpr-button>
                        }
                    }
                </div>
            }

            <div class="agpr-sourceOutletsTab-paginator">
                <agpr-checkbox
                    [id]="id + '_outlets_selectAll_checkbox'"
                    [binary]="true"
                    hiddenLabel="selectAll"
                    [disabled]="!outletList.length"
                    [ngModel]="filteredOutletList?.length > 0 && selectedOutlets?.length >= filteredOutletList?.length"
                    (ngModelChange)="toggleSelectAll()"
                ></agpr-checkbox>
                <span class="agpr-sourceOutletsTab-selectBar">
                    {{ allSelected ? outletList.length : (selectedOutlets?.length || '0') }}
                    <span class="agpr-sourceOutletsTab-selectBar">
                        {{ 'Paginator.of' | localize }}
                        <span class="agpr-sourceOutletsTab-selectBar">
                            {{ filteredOutletList.length || '0' }}
                        </span>
                        {{ 'Paginator.selected' | localize }}
                    </span>
                </span>
                <agpr-minimal-paginator [isDisabled]="!outletList?.length"></agpr-minimal-paginator>
            </div>

            @if (filteredOutletList.length > 0 && selectedOutlets.length >= filteredOutletList?.length) {
                <div class="agpr-sourceOutletsTab-selectAllNotice">
                    @if (allSelected && totalNumberOfPages > 1) {
                        <agpr-message [severity]="messageSeverity.info">
                            <span>
                                {{ 'Discover.targeting.result.selectAll.notice.all' | localize : {count: outletList.length} }}
                            </span>
                            <agpr-button
                                [id]="id + '_toggleSelectAllButton'"
                                class="agpr-sourceOutletsTab-selectAllNotice-link"
                                [style]="buttonType.link"
                                label="Discover.targeting.result.selectAll.hyperlink.clear"
                                (click)="toggleSelectAll()"
                            ></agpr-button>
                        </agpr-message>
                    } @else {
                        @if (!areChipsVisible && (selectedOutlets.length < outletList.length)) {
                            <agpr-message [severity]="messageSeverity.info">
                                <span>
                                    {{ 'Discover.targeting.result.selectAll.notice.page' | localize : { count: selectedOutlets.length } }}
                                </span>
                                <agpr-button
                                    [id]="id + '_selectAllResultsButton'"
                                    class="agpr-sourceOutletsTab-selectAllNotice-link"
                                    [style]="buttonType.link"
                                    [label]="'Discover.targeting.result.selectAll.hyperlink.select' | localize : { count: outletList.length}"
                                    (click)="selectAllResults()"
                                ></agpr-button>
                            </agpr-message>
                        }
                    }
                </div>
            }
        </div>

        <agpr-scroll-panel>
            <ul
                class="agpr-sourceOutletsTab-outlets-list"
                [agprLoading]="loading"
            >
                @if (!filteredOutletList?.length && !loading) {
                    <agpr-message
                        [useWhiteBg]="true"
                        [severity]="messageSeverity.noContent"
                    >
                        <span>{{ 'Discover.targeting.result.noOutletsFound' | localize }}</span>
                    </agpr-message>
                }
                @for (outletInfo of filteredOutletList; track outletInfo.outlet; let checkboxIndex = $index) {
                    <li class="agpr-sourceOutletsTab-outlets-listItem">
                        @if (outletInfo?.outlet?.isAiReference) {
                            <div class="agpr-sourceOutletsTab-label">
                                <span
                                    role="img"
                                    class="fa-kit-duotone fa-agpr-ai-badge"
                                    agprTooltip="Discover.badges.tooltips.outlet.aiReferenceLeader"
                                ></span>
                            </div>
                        }
                        <div class="agpr-contextMenu bottom right">
                            <agpr-button
                                [style]="buttonType.contextMenu"
                                icon="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center"
                                tooltip="Discover.entityProfile.expand"
                                tooltipPosition="top"
                                (click)="expandOutletProfile(outletInfo.outlet.id)"
                            ></agpr-button>
                            <agpr-button
                                class="contextMenu-button"
                                [style]="buttonType.contextMenu"
                                icon="fa-regular fa-duotone fa-user-plus"
                                tooltip="Discover.targeting.actions.manageLists"
                                tooltipPosition="top"
                                (click)="openManageListDialog(outletInfo.outlet)"
                            ></agpr-button>
                        </div>
                        <div class="agpr-sourceOutletsTab-outlets-listItem-outlet">
                            <agpr-checkbox
                                [id]="'aeoScoutDialog_outlet_checkbox' + checkboxIndex"
                                [value]="outletInfo"
                                [(ngModel)]="selectedOutlets"
                                (ngModelChange)="selectedOutletsChanged()"
                            ></agpr-checkbox>

                            <div class="agpr-sourceOutletsTab-outlets-listItem-outlet-content">
                                <div class="agpr-sourceOutletsTab-outlets-listItem-outlet-content-profile">
                                    @if (!outletInfo.imageLoadError) {
                                        <img
                                            class="agpr-sourceOutletsTab-outlets-listItem-outletIcon"
                                            [src]="outletInfo.outlet.avatarUrl"
                                            (error)="outletInfo.imageLoadError = true"
                                            alt=""
                                        />
                                    } @else {
                                        <span class="agpr-sourceOutletsTab-outlets-listItem-outletIconDefault fa-solid fa-globe"></span>
                                    }
                                    <div class="agpr-sourceOutletsTab-outlets-listItem-outlet-content-profileText">
                                        <p class="agpr-sourceOutletsTab-outlets-listItem-outlet-content-profileName agpr-sourceOutletsTab-label-title">
                                            {{ outletInfo.outlet.name }}
                                        </p>
                                        @if (outletInfo.outlet.mediaTypes?.length > 0) {
                                            <div class="agpr-sourceOutletsTab-outlets-listItem-outlet-content-profileText-mediaTypes">
                                                @for (mediaType of outletInfo.outlet.mediaTypes; track mediaType.displayString) {
                                                    <span> {{ mediaType.displayString | localize }}{{ !$last ? ', ' : ''}} </span>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div class="agpr-sourceOutletsTab-outlets-listItem-outlet-content-attribute">
                                    @if (outletInfo.outlet.coverageFocus) {
                                        <span> {{ outletInfo.outlet.coverageFocus.displayString }} </span>
                                    }
                                    <span class="agpr-sourceOutletsTab-outlets-listItem-outlet-content-filler"></span>
                                    @if (outletInfo.circulation) {
                                        <agpr-meta-data
                                            [id]="id + '_outlet_' + checkboxIndex"
                                            [type]="attributeType.audienceReach"
                                            [icon]="outletInfo.reachIcon"
                                            [value]="outletInfo.reachValue"
                                            [isSimilarWeb]="outletInfo.isReachValueFromSimilarWeb"
                                            [tooltip]="outletInfo.reachUnit"
                                            [initiallyFocusable]="checkboxIndex === 0">
                                        </agpr-meta-data>
                                    }
                                </div>
                            </div>
                        </div>
                        <ul class="agpr-sourceOutletsTab-outlets-listItem-answerEngines-list">
                            @for (answerEngine of outletInfo.answerEngines; track answerEngine) {
                                <li class="agpr-sourceOutletsTab-outlets-listItem-answerEngines-listItem">
                                    <span>{{ ('Vi.answerEngineType.' + answerEngine) | localize }}</span>
                                </li>
                            }
                        </ul>
                    </li>
                }
            </ul>
        </agpr-scroll-panel>
    } @else {
        <div class="agpr-sourceOutletsTab-upsell">
            <div class="agpr-sourceOutletsTab-upsell-container">
                <span
                    role="img"
                    class="agpr-sourceOutletsTab-upsell-lockIcon fa-regular fa-lock fa-duotone"
                    aria-labelledby="upsellCard_info"
                ></span>
                <div
                    [id]="id + '_upsellCard_info'"
                    class="agpr-sourceOutletsTab-upsell-info"
                >
                    <span> {{ 'Discover.entityProfile.targetingUpsell.contactMessage'| localize }} </span>
                </div>
                <agpr-button
                    [id]="id + '_recentCoverage_contactButton'"
                    label="Discover.entityProfile.targetingUpsell.contactButton"
                    (click)="openUpsell()"
                    [style]="buttonType.primary"
                ></agpr-button>
            </div>
        </div>
    }
</div>
